import { useContext } from 'react';
import { DataContext } from './DataContext';
import { useEffect } from 'react';

const AppData: any = () => {

    const {
     appLoggedIn,
     appUserData,
     appToken,
     appReloadSpeiseplan,
     appUserSpeiseplanChange,
     appUserVerzehrChange,
     appWarenkorbChange
    } = useContext(DataContext);

    return null
};

export default AppData;
